import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import home from '@/views/home/index'
/* tabbar */
// import tabbar from '@/views/tabbar/tabbar'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/i/:brand/:conference/:code',
      name: 'inviteHasCode'
    },
    {
      path: '/i/:brand/:conference',
      name: 'inviteNoCode'
    },
    {
      path: '/'
    },
    {
      path: '/invitation',
      name: 'invitation',
      meta: {title: '邀请函'},
      component: () => import('@/views/invitation/index')
    },
    {
      path: '/login',
      name: 'login',
      meta: {title: '登录'},
      component: () => import('@/views/user/login')
    },
    {
      path: '/yjj-login',
      name: 'yjjLogin',
      meta: {title: ''},
      component: () => import('@/views/user/yjjLogin')
    },
    {
      path: '/reg-success',
      component: () => import('@/views/user/regSuccess.vue'),
      name: 'regSuccess',
      meta: {title: '报名成功'}
    },
    {
      path: '/entrance',
      component: () => import('@/views/qr/entranceQr.vue'),
      name: 'entranceQr',
      meta: {title: '入场二维码'}
    },
    {
      path: '/share',
      component: () => import('@/views/qr/shareQr.vue'),
      name: 'shareQr',
      meta: {title: '分享邀请'}
    },
    {
      path: '/brand-list',
      component: () => import('@/views/goods/brandList.vue'),
      name: 'brandList',
      meta: {title: '品牌商列表'}
    },
    {
      path: '/goodslist',
      component: () => import('@/views/goods/list.vue'),
      name: 'goodsList',
      meta: {title: '展厅'}
    },
    {
      path: '/goodsdetail',
      component: () => import('@/views/goods/detail.vue'),
      name: 'goodsDetail',
      meta: {title: '商品详情'}
    },
    {
      path: '/conference',
      name: 'conference',
      component: () => import('@/views/home/conference'),
      meta: {title: '首页'}
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/views/home/intro'),
      meta: {title: '简介'}
    },
    {
      path: '/home',
      // component: tabbar,
      // redirect: '/home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页'}
      // children: [{
      //   path: 'home',
      //   component: () => import('@/views/home/index'),
      //   meta: {title: '首页'}
      // }]
    },
    {
      path: '/shopcart',
      // component: tabbar,
      // redirect: '/shopcart/index',
      name: 'shopcart',
      meta: {title: '购物车'},
      component: () => import('@/views/shopcart/index')
      // children: [{
      //   path: 'index',
      //   meta: {title: '购物车'},
      //   component: () => import('@/views/shopcart/index')
      // }]
    },
    {
      path: '/user',
      component: () => import('@/views/user/index'),
      name: 'user',
      meta: {title: '我的'}
    },
    {
      path: '/user-data-edit',
      component: () => import('@/views/user/userDataEdit'),
      name: 'userDataEdit',
      meta: {title: '个人资料'}
    },
    {
      path: '/customer-info',
      component: () => import('@/views/user/customerInfo'),
      name: 'customerInfo',
      meta: {title: '客户详细资料'}
    },
    {
      path: '/favorite',
      component: () => import('@/views/user/favorite'),
      name: 'favorite',
      meta: {title: '收藏夹'}
    },
    {
      path: '/invite-info',
      component: () => import('@/views/user/inviteInfo'),
      name: 'inviteInfo',
      meta: {title: '邀请信息'}
    },
    {
      path: '/address-list',
      component: () => import('@/views/address/list'),
      name: 'addressList',
      meta: {title: '地址'}
    },
    {
      path: '/address-add',
      component: () => import('@/views/address/add'),
      name: 'addressAdd',
      meta: {title: '添加地址'}
    },
    {
      path: '/address-edit',
      component: () => import('@/views/address/edit'),
      name: 'addressEdit',
      meta: {title: '编辑地址'}
    },
    {
      path: '/create-order',
      component: () => import('@/views/order/createOrder'),
      name: 'createOrder',
      meta: {title: '确认订单'}
    },
    {
      path: '/order-detail',
      component: () => import('@/views/order/orderDetail'),
      name: 'orderDetail',
      meta: {title: '订单详情'}
    },
		{
		  path: '/orderPayOption',
		  component: () => import('@/views/order/orderPayOption'),
		  name: 'orderPayOption',
		  meta: {title: '订单支付'}
    },
    {
		  path: '/pay-success',
		  component: () => import('@/views/common/pay-success'),
		  name: 'paySuccess',
		  meta: {title: '支付成功'}
    },
    {
		  path: '/pay-fail',
		  component: () => import('@/views/common/pay-fail'),
		  name: 'payFail',
		  meta: {title: '支付失败'}
		},
    {
      path: '/order',
      // component: tabbar,
      // redirect: '/order/index',
      name: 'order',
      meta: {title: '订单'},
      component: () => import('@/views/order/index')
      // children: [{
      // path: 'index',
      // redirect: '/order/index/all',
      // meta: {title: '订单'},
      // name: 'orderIndex',
      // component: () => import('@/views/order/index') // ,
      // children: [{
      //   path: ':tab',
      //   component: () => import('@/views/order/indexTabItem'),
      // }]
      // }]
    },
    // {
    //   path: '/order',
    //   component: tabbar,
    //   redirect: '/order/index',
    //   name: 'order',
    //   children: [{
    //     path: 'index',
    //     redirect: '/order/index/all',
    //     component: () => import('@/views/order/index'),
    //     children: [{
    //       path: ':tab',
    //       component: () => import('@/views/order/indexTabItem'),
    //     }]
    //   }]
    // },
    // {
    //   path: '/test',
    //   component: () => import('@/views/test/index.vue'),
    //   name: 'test'
    // },
    // {
    //   path: '/pulldown',
    //   component: () => import('@/views/test/pulldown.vue'),
    //   name: 'pulldown'
    // },
    // {
    //   path: '/qrcode',
    //   component: () => import('@/views/test/qrcode.vue'),
    //   name: 'qrcode'
    // },
    // {
    //   path: '/waterfall',
    //   component: () => import('@/views/test/waterfall.vue'),
    //   name: 'waterfall'
    // },
    {
      path: '/test-map',
      component: () => import('@/views/test/map.vue'),
      name: 'testMap'
    },
    {
      path: '/full-reg',
      component: () => import('@/views/user/fullReg.vue'),
      name: 'fullRegTip'
    },
    {
      path: '/404',
      component: () => import('@/views/common/404.vue'),
      name: '404'
    },
    {
      path: '/n-invitation',
      name: 'n-invitation',
      meta: {title: '邀请函'},
      component: () => import('@/views/invitation/newIndex')
    },
    {
      path: '/n-reg1',
      name: 'newReg1',
      meta: {title: '报名-需求信息填写'},
      component: () => import('@/views/user/newReg1.vue')
    },
    {
      path: '/n-reg2',
      name: 'newReg2',
      meta: {title: '报名-个人信息'},
      component: () => import('@/views/user/newReg2.vue')
    },
    {
      path: '/n-login',
      name: 'newLogin',
      meta: {title: '登录'},
      component: () => import('@/views/user/newLogin.vue')
    },
    {path: '*', redirect: '/404'}
  ],
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
  // console.log(to, from)
  // console.log(5435432535345345, savedPosition)
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  // if (to.hash) {
  //   return {
  //     selector: to.hash
  //   }
  // }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js